var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDigit6 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 90,
  height: 90,
  viewBox: "0 0 90 90",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 45,
  fill: "#FFE603"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M47.98 37.878c-.182-.839-.499-1.462-.952-1.87-.454-.43-1.1-.646-1.938-.646-1.292 0-2.222.567-2.788 1.7-.567 1.11-.862 2.879-.884 5.304.498-.793 1.212-1.417 2.142-1.87.952-.453 1.994-.68 3.128-.68 2.221 0 4 .703 5.338 2.108 1.36 1.405 2.04 3.366 2.04 5.882 0 1.655-.34 3.105-1.02 4.352-.658 1.247-1.632 2.221-2.924 2.924-1.27.703-2.777 1.054-4.522 1.054-3.49 0-5.916-1.088-7.276-3.264-1.36-2.199-2.04-5.35-2.04-9.452 0-4.307.714-7.503 2.142-9.588 1.45-2.108 3.762-3.162 6.936-3.162 1.7 0 3.128.34 4.284 1.02 1.178.657 2.062 1.53 2.652 2.618a8.755 8.755 0 0 1 1.088 3.57H47.98Zm-2.686 6.528c-.975 0-1.79.295-2.448.884-.635.567-.952 1.383-.952 2.448 0 1.088.294 1.938.884 2.55.612.612 1.473.918 2.584.918.997 0 1.78-.295 2.346-.884.59-.612.884-1.44.884-2.482 0-1.065-.284-1.904-.85-2.516-.567-.612-1.383-.918-2.448-.918Z",
  fill: "#000"
})));
export default SvgDigit6;